import { Length } from 'class-validator';

export class PublicProfileUpdateModel {
  @Length(2, 128)
  public name: string;

  @Length(0, 350)
  public description: string;

  @Length(0, 2048)
  public bio: string;

  @Length(32, 36, { each: true })
  public attachments: string[];
}
